import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-type-selector.label',
		defaultMessage: 'Jira project',
		description: 'Field label for the Jira project field',
	},
	recommend: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-type-selector.recommend',
		defaultMessage: 'RECOMMENDED',
		description: 'The text for RECOMMENDED lozenge',
	},
});
